import { ResponsiveBar } from "@nivo/bar";
import { getTheme } from "@/components/Decklists/barGraphTheme";
export default function PowerCurve({
  powerDict,
}: {
  powerDict: Record<string, number>;
}) {
  let barGraphData = [];
  for (const [k, v] of Object.entries(powerDict)) {
    barGraphData.push({
      power: k,
      count: v,
    });
  }

  const MyResponsiveBar = ({ data }: { data: any }) => (
    <ResponsiveBar
      animate={false}
      theme={getTheme()}
      data={data as any}
      keys={["count"]}
      indexBy="power"
      margin={{ top: 10, right: 10, bottom: 40, left: 40 }}
      padding={0.3}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={["rgb(126 34 206)"]}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "#38bcb2",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "#eed312",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[]}
      borderColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Power",
        legendPosition: "middle",
        legendOffset: 35,
        truncateTickAt: 0,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Count",
        legendPosition: "middle",
        legendOffset: -35,
        truncateTickAt: 0,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={"rgb(233 213 255)"}
      legends={
        [
          // {
          //   dataFrom: "keys",
          //   anchor: "bottom-right",
          //   direction: "column",
          //   justify: false,
          //   translateX: 120,
          //   translateY: 0,
          //   itemsSpacing: 2,
          //   itemWidth: 100,
          //   itemHeight: 20,
          //   itemDirection: "left-to-right",
          //   itemOpacity: 0.85,
          //   symbolSize: 20,
          //   effects: [
          //     {
          //       on: "hover",
          //       style: {
          //         itemOpacity: 1,
          //       },
          //     },
          //   ],
          // },
        ]
      }
      role="application"
      ariaLabel="Deck cost curve"
      barAriaLabel={(e) =>
        e.id + ": " + e.formattedValue + " in country: " + e.indexValue
      }
    />
  );

  return (
    <div className="bg-default-50 p-4 rounded-lg">
      <div className="mb-2">Power Curve</div>
      <div className="flex justify-center items-center">
        <div className="h-[240px] w-[300px]">
          <MyResponsiveBar data={barGraphData} />
        </div>
      </div>
    </div>
  );
}
